import React from 'react';
import { Link } from 'gatsby';

import whiteLogo from '../../../content/assets/logo-white.svg'
import dogIcon from '../../../content/assets/dog-white.svg'
import catIcon from '../../../content/assets/cat-white.svg'
import closeIcon from '../../../content/assets/close.svg'
import menuIcon from '../../../content/assets/menu.svg'
import headerStyle from './header.module.scss';

class HeaderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSideMenu: false
    }
  }

  toggleSideMenu() {
    this.setState({
      activeSideMenu: !this.state.activeSideMenu
    }, () => {
      // html.style.overflowY = this.state.activeSideMenu ? 'hidden' : 'scroll';
    });
  }

  render() {
    return (
      <header className={headerStyle.header}>
        <div className={headerStyle.header__inner}>
          <Link
            className={headerStyle.logo}
            to={'/'}>
            <img src={whiteLogo} alt="logo" />
          </Link>

          {/* categories */}
          <div className={headerStyle.categories}>
            <div className={headerStyle.dropdown}>
              <div className={headerStyle.dropdown__text}>Собаки</div>
              <img src={dogIcon} alt="dog" className={headerStyle.dropdown__icon} />
              <div className={headerStyle.dropdown__content}>
                {
                  this.props.availableCategories.dogs.map((c) => {
                    return <Link key={c.value} to={`/category/${c.value}`}>{c.name}</Link>
                  })
                }
              </div>
            </div>
            <div className={headerStyle.dropdown}>
              <div className={headerStyle.dropdown__text}>Коти</div>
              <img src={catIcon} alt="cat" className={headerStyle.dropdown__icon} />
              <div className={headerStyle.dropdown__content}>
                {
                  this.props.availableCategories.cats.map((c) => {
                    return <Link key={c.value} to={`/category/${c.value}`}>{c.name}</Link>
                  })
                }
              </div>
            </div>
          </div>
          { /* Mobile view of Categories */}
          <div className={`${headerStyle.sideMenu} ${this.state.activeSideMenu ? headerStyle.sideMenu__active : ''}`}>
            <div onClick={() => this.toggleSideMenu()} className={headerStyle.sideMenu__button}><img src={menuIcon} alt="menu" /></div>
            <div onClick={() => this.toggleSideMenu()} className={headerStyle.sideMenu__overlay}></div>
            <div className={headerStyle.sideMenu__content}>
              <div className={headerStyle.sideMenu__content_inner}>
                <div onClick={() => this.toggleSideMenu()} className={headerStyle.sideMenu__content_inner_close}>
                  <img src={closeIcon} alt="close" />
                </div>
                <div className={headerStyle.sideMenu__content_inner_category}>
                  <div className={headerStyle.sideMenu__content_inner_category_title}>
                    Собаки
                  </div>
                  <div className={headerStyle.sideMenu__content_inner_category_list}>
                    {
                      this.props.availableCategories.dogs.map((c) => {
                        return <Link className={headerStyle.sideMenu__content_inner_category_list_item} key={c.value} to={`/category/${c.value}`}>{c.name}</Link>
                      })
                    }
                  </div>
                </div>
                <div className={headerStyle.sideMenu__content_inner_category}>
                  <div className={headerStyle.sideMenu__content_inner_category_title}>
                    Коти
                  </div>
                  <div className={headerStyle.sideMenu__content_inner_category_list}>
                    {
                      this.props.availableCategories.cats.map((c) => {
                        return <Link className={headerStyle.sideMenu__content_inner_category_list_item} key={c.value} to={`/category/${c.value}`}>{c.name}</Link>
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </header>
    )
  }
}

export default ({ availableCategories, breadcrumbs }) => {
  let breadcrumbsItems = [];
  if (breadcrumbs && breadcrumbs.length) {
    return (
      <div>
        <HeaderComponent availableCategories={availableCategories} />
        <div className={headerStyle.breadcrumbs}>
          {breadcrumbs && breadcrumbs.map((b) => {
            return (
              <Link key={b.slug} to={b.slug || ''} className={headerStyle.breadcrumbs__item}>
                {b.name}
              </Link>
            )
          })}
        </div>
      </div>
    )
  } else {
    return (
        <HeaderComponent availableCategories={availableCategories} />
    )
  }

}